export const redesignTheme = {
  colors: {
    background: '#f2eee8',
    primary: '#000a8d',
    primaryDark: '#000b33',
    text: '#383838',
    textMuted: '#1d2939',
    textBody: '#000000',
    link: '#333333',
    border: '#d8d8d8',
    white: '#ffffff',
    overlay: '#0e1247',
    accentMuted: 'rgba(122, 101, 85, 0.12)',
    otpCard: '#e4ded6',
    placeholder: '#9ca3af',
    error: '#e63c3c',
    hoverSurface: '#f9f9f9',
    surface: '#f7f3eb',
    surfaceBorder: '#e4dfda',
    tableHeader: 'rgba(223, 216, 208, 0.8)',
    label: '#9799b1',
    brownLight: '#7a6555',
    tabInactive: '#e8e1d7',
    tabBorder: 'rgba(122, 101, 85, 0.5)',
    brown: '#634f41',
    brownDark: '#4a392c',
    success: '#149a2e',
    successDark: '#007a55',
    successSurface: '#daf5ed',
    infoDark: '#376e99',
    infoSurface: '#d1eaff',
    notification: '#000b33',
    notificationMuted: 'rgba(255, 255, 255, 0.16)',
    notificationBadge: 'rgba(255, 255, 255, 0.24)',
    progressTrack: 'rgba(0, 10, 141, 0.08)',
    progressTrackNotStarted: 'rgba(230, 224, 216, 0.8)',
    progressTrackMuted: '#e6e0d8',
    textSecondary: 'rgba(56, 56, 56, 0.8)',
    iconSurface: '#e5dfd7',
    cardWarm: '#fdfaf5',
    cardWarmBorder: 'rgba(44, 26, 16, 0.12)',
    sectionHeaderBg: 'rgba(237, 232, 220, 0.4)',
    danger: '#ca4c44',
    dangerSurface: 'rgba(202, 76, 68, 0.08)',
    dangerBorder: 'rgba(202, 76, 68, 0.48)',
    dangerIconSurface: 'rgba(202, 76, 68, 0.16)',
    dangerText: '#ad3932',
    dangerBorderLight: 'rgba(202, 76, 68, 0.24)',
    chatBackdrop: 'rgba(0, 0, 0, 0.6)',
    chatBorder: '#cdceda',
    chatBubbleAssistant: '#edeef2',
    chatMessageText: '#0e1247',
    chatInputPlaceholder: '#838183',
    heroSurface: '#e9e0d3',
    iconMutedSurface: '#ebebef',
    textSubtle: '#7b8599',
    footerSurface: '#fbf9f7',
  },
  fonts: {
    gothic: "'ITC Avant Garde Gothic Std', sans-serif",
    gothicBold: "'ITC Avant Garde Gothic Std Bold', sans-serif",
    gothicSemiBold: "'ITC Avant Garde Gothic Std SemiBold', sans-serif",
    opensans: "'Open Sans', sans-serif",
    opensansBold: "'Open Sans Bold', sans-serif",
    opensansSemiBold: "'Open Sans SemiBold', sans-serif",
  },
  fontSize: {
    xs: 10,
    sm: 12,
    md: 14,
    base: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    intro: 18,
  },
  spacing: {
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48,
  },
  radius: {
    sm: 8,
    md: 16,
    lg: 24,
    section: 40,
  },
  sizes: {
    inputHeight: 40,
    buttonHeight: 40,
    chatPanelWidth: 376,
    chatSendButtonSize: 48,
    contentMaxWidth: 464,
    headingMaxWidth: 400,
    logoWidth: 300,
    logoHeight: 44,
    ebookContentMaxWidth: '66%',
    profilePhotoSize: 200,
    modalMaxWidth: 696,
    contentMaxWidthWide: 1282,
    heroImageSize: 416,
  },
  breakpoints: {
    desktop: 1250,
    /** Admin nav labels are longer; collapse to hamburger earlier to avoid overlap with logo/profile. */
    adminDesktop: 1800,
    tablet: 992,
    mobile: 600,
  },
} as const;

export type RedesignTheme = typeof redesignTheme;
